import {setBusyIndicator} from "../../../app"
import {setNotifications, setNotificationRead, setSelectedNotificationId} from './actions'
import {get} from "../../../utils/api/api"

export const getNotifications = (showLoader = true) => {
  return async (dispatch) => {
    showLoader && dispatch(setBusyIndicator(true))

    const notifications = await get('/viewsjson/notifications', null, dispatch)

    // Convert read to boolean
    notifications?.forEach(a => {
      a.read = parseInt(a.read) === 1
    })

    dispatch(setNotifications(notifications))
    showLoader && dispatch(setBusyIndicator(false))
  }
}

export const markNotificationAsRead = (userId, notificationId) => {
  return async (dispatch) => {
    if (!userId || !notificationId){
      return
    }

    const read = await get('/push_notification/read', `user_id=${userId}&notification_id=${notificationId}`)
    if (read){
      dispatch(setNotificationRead(notificationId))
    }
  }
}

export const selectNotification = (notificationId) => {
  return (dispatch) => {
    dispatch(setSelectedNotificationId(notificationId))
  }
}